import { render, staticRenderFns } from "./newsEdit.vue?vue&type=template&id=44cf9988"
import script from "./newsEdit.vue?vue&type=script&lang=js"
export * from "./newsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cf9988')) {
      api.createRecord('44cf9988', component.options)
    } else {
      api.reload('44cf9988', component.options)
    }
    module.hot.accept("./newsEdit.vue?vue&type=template&id=44cf9988", function () {
      api.rerender('44cf9988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/newsSet/newsEdit.vue"
export default component.exports